/**
 * 暖心期刊 H5 接口（对接 Pear-Admin-Think 后端 /index.php/api/warm/*）
 * 期刊列表/详情请求会带 Token，后端按登录与等级返回不同价格；未登录不返回价格
 */
import { getStoredToken } from './auth'

const BASE = (typeof process !== 'undefined' && process.env?.VUE_APP_API_BASE) || '/api'

function request(path, params = {}, options = {}) {
  const cleaned = {}
  if (params && typeof params === 'object') {
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== null && v !== '') {
        cleaned[k] = String(v)
      }
    }
  }
  const url = Object.keys(cleaned).length
    ? BASE + path + '?' + new URLSearchParams(cleaned).toString()
    : BASE + path
  const token = options.token !== undefined ? options.token : getStoredToken()
  const headers = token ? { Token: token } : {}
  return fetch(url, {
    credentials: 'omit',
    ...(Object.keys(headers).length ? { headers } : {})
  })
    .then(res => res.json())
    .then(data => {
      if (data.code !== 200 && data.code !== 0) throw new Error(data.msg || '请求失败')
      return data
    })
}

export default {
  getDirections() {
    return request('/warm/directions').then(r => r.data)
  },
  getOptions() {
    return request('/warm/options').then(r => r.data)
  },
  /** 筛选分类聚合：一次返回 { directions, options } */
  getFilter() {
    return request('/warm/filter').then(r => r.data)
  },
  getJournals(params) {
    return request('/warm/journals', params, { token: getStoredToken() }).then(r => ({
      list: r.data || [],
      count: r.count || 0,
      limit: r.limit || 10
    }))
  },
  getDetail(id) {
    return request('/warm/detail/' + id, {}, { token: getStoredToken() }).then(r => r.data)
  },
  getStats() {
    return request('/warm/stats').then(r => r.data)
  }
}
